import React from 'react';
import { Button } from 'antd';
import { LinkOutlined } from '@ant-design/icons';

const ConsoleLink = ({ url, isLocal, children = 'View in AWS Console' }) => {
  if (isLocal || !url) {
    return null;
  }

  return (
    <Button
      type="link"
      icon={<LinkOutlined />}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ padding: 0 }}
    >
      {children} →
    </Button>
  );
};

export default ConsoleLink;
